interface SyncStatusProps {
  isSyncing: boolean;
  pendingCount: number;
  lastSyncAt: Date | null;
  conflictCount: number;
  onSync: () => void;
}

export function SyncStatus({ isSyncing, pendingCount, lastSyncAt, conflictCount, onSync }: SyncStatusProps) {
  const hasConflicts = conflictCount > 0;
  const label = isSyncing
    ? 'Syncing…'
    : hasConflicts
    ? `${conflictCount} conflict${conflictCount > 1 ? 's' : ''} — cloud overwrote local edits`
    : pendingCount > 0
    ? `${pendingCount} unsynced`
    : lastSyncAt
    ? `Synced ${lastSyncAt.toLocaleTimeString()}`
    : 'Cloud connected';

  const color = isSyncing
    ? '#6366f1'
    : hasConflicts
    ? '#ef4444'
    : pendingCount > 0
    ? '#f59e0b'
    : '#22c55e';

  return (
    <button
      onClick={onSync}
      disabled={isSyncing}
      title={label}
      style={{
        display: 'flex', alignItems: 'center', gap: '0.35rem',
        background: 'var(--bg)', border: `1.5px solid ${color}`,
        borderRadius: '8px', color, fontSize: '0.78rem', fontWeight: 600,
        padding: '0.28rem 0.65rem', lineHeight: 1,
        transition: 'background 0.15s, border-color 0.15s',
        opacity: isSyncing ? 0.7 : 1,
      }}
    >
      <span style={{ fontSize: '0.85rem' }}>
        {isSyncing ? '⟳' : hasConflicts ? '⚠' : pendingCount > 0 ? '☁' : '✓'}
      </span>
      <span className="sm-show">{label}</span>
    </button>
  );
}
